import chroma from 'chroma-js';

type ColorPalette = Record<string, string>;

export const generateColorPalette = (baseColor: string): Record<string, ColorPalette> => {
  const lightPalette: ColorPalette = {
    100: chroma(baseColor).set('hsl.l', 0.97).hex(),
    200: chroma(baseColor).set('hsl.l', 0.90).hex(),
    300: chroma(baseColor).set('hsl.l', 0.85).hex(),
    400: chroma(baseColor).set('hsl.l', 0.80).hex(),
    500: chroma(baseColor).set('hsl.l', 0.75).hex(),
    600: chroma(baseColor).set('hsl.l', 0.65).hex(),
    700: chroma(baseColor).set('hsl.l', 0.60).hex(),
    800: chroma(baseColor).set('hsl.l', 0.50).hex(),
    900: chroma(baseColor).set('hsl.l', 0.40).hex(),
    1000: chroma(baseColor).set('hsl.l', 0.30).hex(),
    1100: chroma(baseColor).set('hsl.l', 0.20).hex(),
    1200: chroma(baseColor).set('hsl.l', 0.10).hex(),
  };

  const darkPalette: ColorPalette = {
    100: chroma(baseColor).set('hsl.l', 0.05).hex(),
    200: chroma(baseColor).set('hsl.l', 0.10).hex(),
    300: chroma(baseColor).set('hsl.l', 0.15).hex(),
    400: chroma(baseColor).set('hsl.l', 0.20).hex(),
    500: chroma(baseColor).set('hsl.l', 0.25).hex(),
    600: chroma(baseColor).set('hsl.l', 0.35).hex(),
    700: chroma(baseColor).set('hsl.l', 0.40).hex(),
    800: chroma(baseColor).set('hsl.l', 0.45).hex(),
    900: chroma(baseColor).set('hsl.l', 0.50).hex(),
    1000: chroma(baseColor).set('hsl.l', 0.60).hex(),
    1100: chroma(baseColor).set('hsl.l', 0.70).hex(),
    1200: chroma(baseColor).set('hsl.l', 0.80).hex(),
  };

  return {
    light: lightPalette,
    dark: darkPalette,
  };
};

